import { messages } from '../../messages';
export const toMessage = (defaultMessage, key) => {
  try {
    if (key !== undefined && key in messages) {
      return messages[key];
    }
    return defaultMessage;
  } catch {
    return defaultMessage;
  }
};